import React, { useState } from "react";
import NuAmount from "../../../../../Components/Utils/NuAmount";
import ViewMore from "./ViewMore";
import NuNumber from "../../../../../Components/Utils/NuNumber";


const ExpandableManpower = ({data,getData, titleId, selectedExpandedItems, onExpandedCheckboxChange,estimationId,Role}) => {
  return (
    <>
    {
        data.map((item, index) => (
            <tr className={`w-[100%] even:bg-white odd:bg-gray-50 text-xs font-normal text-[#4f4768]`} 
            // style={{borderBottom:'1px solid #c7dfe0'}} 
            key={index}>
            <td className=" w-[5%] py-3 px-1">
                <div className=" w-full gap-1 flex">
                <input 
            type="checkbox" 
            checked={selectedExpandedItems[titleId]?.includes(item.id) || false}
            onChange={() => onExpandedCheckboxChange(titleId, item.id)}
            />
                {index+1}
                </div>
            </td>
            <td className=" w-[20%] py-3 px-1 font-normal text-[#4f4768]">{item?.role||"-"}</td>
            <td className=" w-[15%] py-3 px-1 font-normal text-[#4f4768]">{item?.type == 0?"Own":"Rental"}</td>
            <td className=" w-[15%] py-3 px-1 font-normal text-[#4f4768]">{item?.quantity||"-"}</td>
            <td className=" w-[10%] py-3 px-1 font-normal text-[#4f4768]">{item?.days||"-"}</td>
            <td className=" w-[15%] py-3 px-1 font-normal text-[#4f4768] text-center">{<NuNumber value={item?.amount||0}/>||"-"}</td>
            <td className=" w-[5%] py-3 px-1 font-normal text-[#4f4768]">
            <ViewMore id={titleId || ""}
                            getData={getData}
                            data={item}
                            estimationId={estimationId}
                            Role={Role}
                            /> 

            </td>
           </tr>
        ))
    }
    </>
  );
};

export default ExpandableManpower;
